import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 16px;
  max-width: 100%;

  @media (min-width: 768px) {
    padding: 24px;
  }
`;